import styled from 'styled-components';

export const TicketCard = styled.article`
  position: relative;

  margin: 0 -10px;

  border-radius: 6px;

  transition: box-shadow 0.3s;

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);

    h3 {
      color: ${({ theme }) => theme.blue};
    }
  }

  a {
    display: block;
    padding: 20px 10px;
    color: inherit;

    @media(min-width: 1024px) {
      padding: 30px;
    }
  }

  @media(min-width: 1024px) {
    margin: 0 -30px;
  }
`;

export const TicketRow = styled.div`
  display: flex;

  &:first-child {
    margin-bottom: 15px;
  }

  @media(min-width: 1024px) {
    &:first-child {
      margin-bottom: 0;
    }

    &:last-child {
      position: absolute;
      bottom: 30px;
      left: 135px;
    }
  }
`;

export const TicketPreview = styled.div`
  width: 63px;
  height: 63px;
  flex-shrink: 0;
  margin-right: 10px;

  border-radius: 6px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;

    object-fit: cover;
  }

  @media(min-width: 1024px) {
    width: 80px;
    height: 80px;
    margin-right: 25px;
  }
`;

export const TicketContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  font-size: 12px;
  line-height: 1;

  @media(min-width: 768px) {
    font-size: 16px;
  }

  @media(min-width: 1024px) {
    font-size: 20px;
  }
`;

export const TicketHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const TicketMore = styled.button`
  position: absolute;
  top: 0;
  right: -5px;

  display: flex;
  align-items: center;
  height: 4px;
  margin: 0;
  padding: 15px;

  color: ${({ theme }) => theme.blue};
  background-color: transparent;
  border: none;

  cursor: pointer;

  svg {
    pointer-events: none;
    transition: fill 0.3s;
    fill: ${({ theme }) => theme.black};
  }

  &:hover svg {
    fill: ${({ theme }) => theme.blue};
  }

  @media(min-width: 1024px) {
    top: 25px;
    right: 20px;
  }
`;

export const TicketList = styled.ul`
  display: flex;
  align-items: center;
`;

export const TicketItem = styled.li`
  font-size: 10px;

  color: ${({ theme, status }) => {
    switch (status) {
      case "Active":
        return theme.green;
      case "Expired":
        return theme.red;
      case "Redeemed":
      case "Refunded":
        return theme.blue;
      default:
        return 'inherit';
    }
  }};

  @media(min-width: 1024px) {
    font-size: 12px;
  }

  &:not(:last-child) {
    position: relative;

    margin-right: 15px;

    &::after {
      content: "";

      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: -10px;

      width: 4px;
      height: 4px;

      background-color: #9a9a9a;
      border-radius: 50%;
    }
  }
`;

export const TicketHeading = styled.h3`
  margin: 0;
  margin-bottom: auto;
  padding: 0;

  font-size: inherit;

  transition: color 0.3s;

  a {
    display: block;

    color: inherit;
  }
`;

export const TicketPrice = styled.p`
  margin: 0;
  padding: 0;

  font-weight: 700;

  @media(min-width: 1024px) {
    text-align: right;
  }
`;

export const TicketOptions = styled.ul`
  position: absolute;
  z-index: 1;
  top: 30px;
  right: 10px;

  width: 220px;
  display: ${({ shown }) => shown ? 'block' : 'none'};

  background: ${({ theme }) => theme.white};
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.1);
  border-radius: 6px 6px 12px 12px;
  overflow: hidden;

  .react-add-to-calendar__button {
    width: 100%;
    margin: 0;
    padding: 10px 20px;

    font-size: 16px;
    line-height: 1;
    text-align: left;

    cursor: pointer;

    transition: color 0.3s, background-color 0.3s;

    &:hover {
      color: ${({ theme }) => theme.blue};

      background-color: #f8f8f8;
    }

    &.cancel {
      color: ${({ theme }) => theme.red};
    }
  }

  .react-add-to-calendar {
    position: relative;

    user-select: none;

    &::after {
      content: '';

      position: absolute;
      top: 18px;
      transform: translateY(-50%) rotate(90deg);
      right: 20px;

      display: inline-block;
      width: 6px;
      height: 9px;
      margin-left: 20px;

      background: transparent no-repeat center / contain;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='9' fill='none'%3E%3Cpath fill='%232CB8FE' fill-rule='evenodd' stroke='%232CB8FE' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M1 8l4-3.5L1 1v7z' clip-rule='evenodd'/%3E%3C/svg%3E");

      transition: background-image 0.3s, margin-left 0.3s;

      pointer-events: none;
    }

    .react-add-to-calendar__button {
      display: inline-block;
      width: 100%;
    }
  }

  .react-add-to-calendar__dropdown {
    a {
      display: inline-block;
      width: 100%;
      padding: 10px 20px;
      padding-left: 30px;

      color: ${({ theme }) => theme.blue};

      transition: background-color 0.3s;

      &:hover {
        background-color: #f8f8f8;
      }
    }
  }

  @media(min-width: 768px) {
    width: 255px;
  }

  @media(min-width: 1024px) {
    top: 55px;

    font-size: 16px;
  }
`;

export const TicketOption = styled.button`
  width: 100%;
  padding: 15px 20px;

  line-height: 1;
  color: ${({ theme, red }) => red ? theme.red : theme.black};
  text-align: left;

  transition: background-color 0.3s;

  &:hover {
    background-color: #f8f8f8;
  }
`;

export const TicketInfo = styled.ul`
  display: flex;
  justify-content: space-between;
  width: 100%;

  font-size: 10px;
  line-height: 1;

  li {
    display: flex;
    align-items: center;
  }

  svg {
    margin-right: 5px;
    fill: none;
    stroke: ${({ theme }) => theme.black}
  }

  @media(min-width: 1024px) {
    font-size: 16px;

    li:not(:last-child) {
      margin-right: 30px;
    }

    svg {
      margin-right: 10px;
    }
  }
`;

export const TicketStars = styled.div`
  position: absolute;
  right: 60px;
  top: 35px;
`;
